import React, { useEffect, useState } from 'react'
import VideoModal from '../../HomePages/home-one/section/videoModal';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
import WhyStudyAbroad from './WhyStudyAbroad'
import Browse from './Browse'
import Whatsnew2 from './whatsnew2'
import StartTestimonials from './testimonials'
// import Aboutsection from './aboutsection'
// import IndividualUniversity from './IndividualUniversity'
import CountUp from 'react-countup'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useGetgetScholarShipUserwithlevel_destiPageApiQuery } from '../../../core/Features/api/findACourse/scholarships/scholarships';
import Unlock from '../../HomePages/home-palani/section/Unlock';
// import Destination from './Destination'
// import Whatsnew from './whatsnew'
// import Benefits from './Benefits'
// import About from './about-us'

const Scholarships = () => {

    const { data, isLoading, isError } = useGetgetScholarShipUserwithlevel_destiPageApiQuery({});
    const apiValues = data?.data || {};
    console.log("Scholarships API Data:", apiValues);

    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animate only once
        });
    }, []);


    return (
        <>
            <>

                {/* banner */}

                  <section className="relative py-10 sm:py-20">
                    {/* Dynamic Background Image */}
                    <div
                        className="absolute inset-0  bg-no-repeat z-[-1]"
                        style={{
                            backgroundImage: `url(${apiValues?.scholarship?.bannerImageUrl})`,
                                                        backgroundSize:"100% 100%",

                        }}
                    />

                    {/* Optional: Dark Overlay */}
                    <div className="absolute inset-0 bg-black/60 z-[-1]" />

                    {/* Content */}
                    <div className="container relative">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="d-sm-flex align-items-center justify-content-sm-between mt-5">
                                    <div className="d-flex text-start align-items-center justify-content-sm-start justify-content-center">
                                        <div className="ms-2">
                                            <h6 className="fs-18 text-white">
                                                {apiValues?.scholarship?.bannerTitle}
                                            </h6>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

               


                <div className='p-1'>


                    <WhyStudyAbroad apiValues={apiValues} />
                    <Browse apiValues={apiValues} />
                    <Whatsnew2 apiValues={apiValues} />
                    {/* <StartTestimonials /> */}
                    <Unlock />

                </div>

               

            </>

        </>
    )
}

export default Scholarships




